module.exports = __webpack_public_path__ + "img/@logo_sslife@3x.e6f343f9.png";